import { EnglishConfig } from './english.config';
import { FrenchConfig } from './french.config';
import { Currency, LanguageConfig, Locale } from './language.config';

class NumberConverter {
  private configs: { [key in Locale]: LanguageConfig };

  constructor() {
    this.configs = {
      en: new EnglishConfig(),
      fr: new FrenchConfig(),
    };
  }

  numberToWords(num: number, language: Locale = 'en'): string {
    const config = this.configs[language];
    if (!config) throw new Error(`Unsupported language: ${language}`);
    return config.numberToWords(num);
  }

  currencyToWords(
    amount: number,
    currency: Currency = 'Franc CFA',
    language: Locale = 'en',
  ): string {
    const config = this.configs[language];
    if (!config) throw new Error(`Unsupported language: ${language}`);
    return config.currencyToWords(amount, currency);
  }
}

export default new NumberConverter();
